import { title, whiteColor } from "assets/jss/material-dashboard-pro-react.jsx";

const errorPageStyles = () => ({
  contentCenter: {
    position: "absolute",
    top: "50%",
    left: "50%",
    zIndex: "3",
    transform: "translate(-50%,-50%)",
    textAlign: "center",
    color: whiteColor,
    padding: "0 15px",
    width: "100%",
    maxWidth: "880px"
  },
  title: {
    ...title,
    fontSize: "5em",
    color: whiteColor,
    letterSpacing: "14px",
    fontWeight: "700",
    marginTop: '10px',
    marginBottom: '10px',
  },
  subTitle: {
    fontSize: "2.25rem",
    marginTop: "10px",
    marginBottom: "10px"
  },
  description: {
    fontSize: "1.125rem",
    marginTop: "10px",
    marginBottom: "10px"
  }
});

export default errorPageStyles;
